import { useRef } from "react";
import styled from "styled-components"
import { ReactComponent as FileUpload } from '../../../assets/svgIcon/input/fileUpload.svg'
import { ReactComponent as DeleteIcon } from '../../../assets/svgIcon/shipment/DeleteOutlined.svg'

export const UploadFile = ({ files, setFiles }) => {
    const fileInputRef = useRef(null);

    const handleClick = () => {
        fileInputRef.current.click();
    };

    const handleFileChange = (event) => {
        // handle file upload logic here
        const files = Array.from(event.target.files);
        setFiles(state => [...files, ...state])
    };

    const handleDrop = (event) => {
        event.preventDefault();
        const files = Array.from(event.dataTransfer.files);
        setFiles(state => [...files, ...state])
    };

    const handleDragOver = (event) => {
        event.preventDefault();
    };
    const handleDelete = (ind) => {
        const uploadingFiles = [...files];
        uploadingFiles.splice(ind, 1);
        setFiles(uploadingFiles);
    };
    return (
        <UploadFileCss>
            <label className="file-upload-label">File Upload <span className="requiredCol">*</span></label>
            <div
                className="file-drop-box"
                onClick={handleClick}
                onDrop={handleDrop}
                onDragOver={handleDragOver}
            >
                <span className="plus-icon">+</span>
                <p>Drag & drop or click to upload files</p>
                <input
                    type="file"
                    ref={fileInputRef}
                    onChange={handleFileChange}
                    style={{ display: "none" }}
                    multiple={true}
                />
            </div>

            <div className="forShowFile">
                {files.length > 0 && files?.map((file, ind) => (

                    <div key={file.name + file.size + ind} className="fileName">
                        <span>
                            <FileUpload />
                            {file.name}
                        </span>
                        <span className="iconWrapper">
                            <DeleteIcon onClick={() => handleDelete(ind)} />
                        </span>
                    </div>
                ))

                }
            </div>
            <div className="borderLine"></div>

        </UploadFileCss>
    )
}

const UploadFileCss = styled.div`
display: flex;
flex-direction: column;
gap: 4px; 
cursor: pointer;

color: var(--GREY, #4A4A68); 
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 22.001px;
 
        .file-upload-container {
  font-family: sans-serif;
}

.file-upload-label {
    color: var(--GREY, #4A4A68);
    font-feature-settings: 'liga' off, 'clig' off; 
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
}

.requiredCol {
  color: red;
}

.file-drop-box {
  text-align: center; 
  height: 70px;
  border-radius: 2px;
  border: 1px dashed #D9D9D9;
  background: var(--MIST, #F7F8F9);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 4px;
  margin-bottom: 10px;

  >p{
    margin: 0;
  }
}

.plus-icon {
    font-size: 28px;
    font-weight: 300;
}

.forShowFile{
    height: 90px;
    overflow-y: auto;

    >.fileName{
        display: flex;
        justify-content: space-between;
        align-items: center;
        span{
            display: flex;
            gap: 4px;
            align-items: center;
        }
    }
}

.borderLine{
    border-radius: 4px 4px 0px 0px;
    background: #FFF;
    box-shadow: 0px -2px 4px 0px rgba(0, 0, 0, 0.10); 
    height: 2px;

}

    
`
